export default {
    account_my_profile: "account_my_profile",
    account_my_profile_mfa_settings: "account_my_profile_mfa_settings",
    account_my_profile_notifications: "account_my_profile_notifications",
    account_my_profile_password: "account_my_profile_password",
    action_type: "action_type",
    admin_account_permissions: "admin_account_permissions",
    admin_consent_settings_activate: "admin_consent_settings_activate",
    admin_consent_settings_create: "admin_consent_settings_create",
    admin_consent_settings_deactivate: "admin_consent_settings_deactivate",
    admin_consent_settings_list: "admin_consent_settings_list",
    admin_consent_settings_record: "admin_consent_settings_record",
    admin_consent_settings_update: "admin_consent_settings_update",
    admin_dashboard: "admin_dashboard",
    admin_dashboard_follow_up_records: "admin_dashboard_follow_up_records",
    admin_document_management: "admin_document_management",
    admin_document_management_item: "admin_document_management_item",
    admin_document_management_item_activate: "admin_document_management_item_activate",
    admin_document_management_item_approved: "admin_document_management_item_approved",
    admin_document_management_item_create: "admin_document_management_item_create",
    admin_document_management_item_deactivate: "admin_document_management_item_deactivate",
    admin_document_management_item_unapproved: "admin_document_management_item_unapproved",
    admin_document_management_item_update: "admin_document_management_item_update",
    admin_document_public: "admin_document_public",
    admin_document_training: "admin_document_training",
    admin_drug_management: "admin_drug_management",
    admin_drug_management_activate: "admin_drug_management_activate",
    admin_drug_management_bulk_action: "admin_drug_management_bulk_action",
    admin_drug_management_courier_sent_to_the_patient: "admin_drug_management_courier_sent_to_the_patient",
    admin_drug_management_deactivate: "admin_drug_management_deactivate",
    admin_drug_management_item: "admin_drug_management_item",
    admin_drug_management_lost: "admin_drug_management_lost",
    admin_drug_management_no_longer_available_offline: "admin_drug_management_no_longer_available_offline",
    admin_drug_management_quarantined_by_depot: "admin_drug_management_quarantined_by_depot",
    admin_drug_management_quarantined_by_fridge: "admin_drug_management_quarantined_by_fridge",
    admin_drug_management_quarantined_by_manufacturer: "admin_drug_management_quarantined_by_manufacturer",
    admin_drug_management_quarantined_by_pharmacy: "admin_drug_management_quarantined_by_pharmacy",
    admin_drug_management_ready_to_dispense: "admin_drug_management_ready_to_dispense",
    admin_drug_management_received_by_depot: "admin_drug_management_received_by_depot",
    admin_drug_management_received_by_fridge: "admin_drug_management_received_by_fridge",
    admin_drug_management_received_by_pharmacy: "admin_drug_management_received_by_pharmacy",
    admin_drug_management_returned_by_patient: "admin_drug_management_returned_by_patient",
    admin_drug_management_returned_destroyed: "admin_drug_management_returned_destroyed",
    admin_drug_management_reviewed_by_depot: "admin_drug_management_reviewed_by_depot",
    admin_drug_management_reviewed_by_fridge: "admin_drug_management_reviewed_by_fridge",
    admin_drug_management_reviewed_by_manufacturer: "admin_drug_management_reviewed_by_manufacturer",
    admin_drug_management_reviewed_by_pharmacy: "admin_drug_management_reviewed_by_pharmacy",
    admin_drug_management_sent_back_to_depot: "admin_drug_management_sent_back_to_depot",
    admin_drug_management_sent_back_to_manufacturer: "admin_drug_management_sent_back_to_manufacturer",
    admin_drug_management_sent_back_to_pharmacy: "admin_drug_management_sent_back_to_pharmacy",
    admin_drug_management_transfer: "admin_drug_management_transfer",
    admin_drug_management_transfer_confirm: "admin_drug_management_transfer_confirm",
    admin_drug_management_update: "admin_drug_management_update",
    admin_drug_management_upload: "admin_drug_management_upload",
    admin_follow_up_item: "admin_follow_up_item",
    admin_follow_up_item_create: "admin_follow_up_item_create",
    admin_follow_up_item_deactivate: "admin_follow_up_item_deactivate",
    admin_follow_up_item_lock: "admin_follow_up_item_lock",
    admin_follow_up_item_unlock: "admin_follow_up_item_unlock",
    admin_follow_up_item_update: "admin_follow_up_item_update",
    admin_general_settings_activate: "admin_general_settings_activate",
    admin_general_settings_create: "admin_general_settings_create",
    admin_general_settings_create_update: "admin_general_settings_create_update",
    admin_general_settings_deactivate: "admin_general_settings_deactivate",
    admin_general_settings_list: "admin_general_settings_list",
    admin_general_settings_record: "admin_general_settings_record",
    admin_general_settings_update: "admin_general_settings_update",
    admin_permissions_list: "admin_permissions_list",
    admin_report_all_vials_pdf: "admin_report_all_vials_pdf",
    admin_report_drugs: "admin_report_drugs",
    admin_report_drugs_by_depot: "admin_report_drugs_by_depot",
    admin_report_drugs_by_depot_pdf: "admin_report_drugs_by_depot_pdf",
    admin_report_drugs_pdf: "admin_report_drugs_pdf",
    admin_report_sites: "admin_report_sites",
    admin_report_sites_pdf: "admin_report_sites_pdf",
    admin_report_subjects: "admin_report_subjects",
    admin_report_subjects_pdf: "admin_report_subjects_pdf",
    admin_report_users: "admin_report_users",
    admin_report_users_pdf: "admin_report_users_pdf",
    admin_report_finance: "admin_report_finance",
    admin_report_finance_pdf: "admin_report_finance_pdf",
    admin_sae_item: "admin_sae_item",
    admin_sae_item_activated: "admin_sae_item_activated",
    admin_sae_item_create: "admin_sae_item_create",
    admin_sae_item_deactivated: "admin_sae_item_deactivated",
    admin_sae_item_lock: "admin_sae_item_lock",
    admin_sae_item_unlock: "admin_sae_item_unlock",
    admin_sae_item_update: "admin_sae_item_update",
    admin_sae_list: "admin_sae_list",
    admin_scheduled_subject_profile_upload_read: "admin_scheduled_subject_profile_upload_read",
    admin_scheduled_upload_settings: "admin_scheduled_upload_settings",
    admin_api_management_ibm_item: "admin_api_management_ibm_item",
    admin_api_management_ibm_create: "admin_api_management_ibm_create",
    admin_api_management_ibm_deactivate: "admin_api_management_ibm_deactivate",
    admin_api_management_ibm_activate: "admin_api_management_ibm_activate",
    admin_api_management_ecoa_item: "admin_api_management_ecoa_item",
    admin_api_management_ecoa_create: "admin_api_management_ecoa_create",
    admin_api_management_ecoa_deactivate: "admin_api_management_ecoa_deactivate",
    admin_api_management_ecoa_activate: "admin_api_management_ecoa_activate",
    admin_api_management_imednet_item: "admin_api_management_imednet_item",
    admin_api_management_imednet_create: "admin_api_management_imednet_create",
    admin_api_management_imednet_deactivate: "admin_api_management_imednet_deactivate",
    admin_api_management_imednet_activate: "admin_api_management_imednet_activate",
    admin_api_management_datafax_item: "admin_api_management_datafax_item",
    admin_api_management_datafax_create: "admin_api_management_datafax_create",
    admin_api_management_datafax_deactivate: "admin_api_management_datafax_deactivate",
    admin_api_management_datafax_activate: "admin_api_management_datafax_activate",
    admin_site_create: "admin_site_create",
    admin_site_item: "admin_site_item",
    admin_site_item_activate: "admin_site_item_activate",
    admin_site_item_deactivate: "admin_site_item_deactivate",
    admin_site_item_update: "admin_site_item_update",
    admin_site_list: "admin_site_list",
    admin_site_randomization_activate: "admin_site_randomization_activate",
    admin_site_randomization_deactivate: "admin_site_randomization_deactivate",
    admin_subject_profile_upload: "admin_subject_profile_upload",
    admin_unblinding_request_create: "admin_unblinding_request_create",
    admin_unblinding_request_item_approved: "admin_unblinding_request_item_approved",
    admin_unblinding_request_item_deactivate: "admin_unblinding_request_item_deactivate",
    admin_unblinding_request_item_unapproved: "admin_unblinding_request_item_unapproved",
    admin_unblinding_request_management_item_activate: "admin_unblinding_request_management_item_activate",
    admin_user_roles_create: "admin_user_roles_create",
    admin_user_roles_item: "admin_user_roles_item",
    admin_user_roles_item_activate: "admin_user_roles_item_activate",
    admin_user_roles_item_deactivate: "admin_user_roles_item_deactivate",
    admin_user_roles_item_update: "admin_user_roles_item_update",
    admin_user_roles_list: "admin_user_roles_list",
    admin_user_site_access_activate: "admin_user_site_access_activate",
    admin_user_site_access_create: "admin_user_site_access_create",
    admin_user_site_access_deactivate: "admin_user_site_access_deactivate",
    admin_user_site_access_update: "admin_user_site_access_update",
    admin_users_item: "admin_users_item",
    admin_users_item_activate: "admin_users_item_activate",
    admin_users_item_create: "admin_users_item_create",
    admin_users_item_deactivate: "admin_users_item_deactivate",
    admin_users_item_list: "admin_users_item_list",
    admin_users_item_update: "admin_users_item_update",
    admin_users_list: "admin_users_list",
    audit_log_item: "audit_log_item",
    audit_log_item_activate: "audit_log_item_activate",
    audit_log_item_deactivate: "audit_log_item_deactivate",
    audit_log_item_edit: "audit_log_item_edit",
    audit_log_item_email_resend: "audit_log_item_email_resend",
    audit_log_item_reviewed: "audit_log_item_reviewed",
    audit_log_item_unreviewed: "audit_log_item_unreviewed",
    audit_log_list: "audit_log_list",
    audit_log_simulation_generate_csv: "audit_log_simulation_generate_csv",
    audit_log_simulation_item: "audit_log_simulation_item",
    audit_log_simulation_item_activate: "audit_log_simulation_item_activate",
    audit_log_simulation_item_create: "audit_log_simulation_item_create",
    audit_log_simulation_item_deactivate: "audit_log_simulation_item_deactivate",
    audit_log_simulation_item_update: "audit_log_simulation_item_update",
    audit_log_simulation_list: "audit_log_simulation_list",
    consent: "consent",
    consent_recorded_notification_email: "consent_recorded_notification_email",
    consent_step_1: "consent_step_1",
    consent_step_3_electronic: "consent_step_3_electronic",
    consent_step_3_paper: "consent_step_3_paper",
    contact_us: "contact_us",
    contact_us_email: "contact_us_email",
    death_occurred_notification_email: "death_occurred_notification_email",
    document_approved_notification_email: "document_approved_notification_email",
    document_pending_approval_notification_email: "document_pending_approval_notification_email",
    drug_low_stock_notification_email: "drug_low_stock_notification_email",
    drug_management_dispensing_site_list: "drug_management_dispensing_site_list",
    drug_management_get_from_site_list: "drug_management_get_from_site_list",
    drug_management_get_to_site_list: "drug_management_get_to_site_list",
    drug_management_site_list: "drug_management_site_list",
    drug_reallocation_detailed_email: "drug_reallocation_detailed_email",
    drug_reallocation_summary_email: "drug_reallocation_summary_email",
    ibm_post_integration: "ibm_post_integration",
    ecoa_post_integration: "ecoa_post_integration",
    new_site_notification_email: "new_site_notification_email",
    new_user_welcome_email: "new_user_welcome_email",
    owned_site_list: "owned_site_list",
    patient_drug_reallocate: "patient_drug_reallocate",
    patient_item: "patient_item",
    patient_item_activate: "patient_item_activate",
    patient_item_deactivate: "patient_item_deactivate",
    patient_list: "patient_list",
    patient_list_by_event: "patient_list_by_event",
    patient_list_by_site: "patient_list_by_site",
    patient_profile_item: "patient_profile_item",
    patient_profile_item_create: "patient_profile_item_create",
    patient_profile_item_lock: "patient_profile_item_lock",
    patient_profile_item_unlock: "patient_profile_item_unlock",
    patient_profile_item_update: "patient_profile_item_update",
    patient_profile_list: "patient_profile_list",
    randomization: "randomization",
    randomization_follow_up_create: "randomization_follow_up_create",
    randomization_rate_limit: "randomization_rate_limit",
    report_all_vials_pdf_email: "report_all_vials_pdf_email",
    report_subject_summary_notification_email: "report_subject_summary_notification_email",
    sae_occurred_notification_email: "sae_occurred_notification_email",
    sae_reporting: "sae_reporting",
    scheduled_unblinding_disable_task: "scheduled_unblinding_disable_task",
    scheduled_upload_task: "scheduled_upload_task",
    scheduled_upload_ibm_api_three: "scheduled_upload_ibm_api_three",
    scheduled_upload_ibm_api_three_task: "scheduled_upload_ibm_api_three_task",
    scheduled_imednet_api_three_pull_subjects_visits: "scheduled_imednet_api_three_pull_subjects_visits",
    scheduled_imednet_api_two_pull_subjects_updates: "scheduled_imednet_api_two_pull_subjects_updates",
    scheduled_datafax_api_two_pull_subjects_updates: "scheduled_datafax_api_two_pull_subjects_updates",
    datafax_api_post_subject: "datafax_api_post_subject",
    scheduled_datafax_api_three_pull_subjects_visits: "scheduled_datafax_api_three_pull_subjects_visits",
    seven_day_follow_up_completed_notification_email: "seven_day_follow_up_completed_notification_email",
    seven_day_reminder_notification_email: "seven_day_reminder_notification_email",
    site_access_list: "site_access_list",
    site_suspended_notification_email: "site_suspended_notification_email",
    sms: "sms",
    subject_depot_randomization_detailed_email: "subject_depot_randomization_detailed_email",
    subject_randomization_detailed_email: "subject_randomization_detailed_email",
    subject_randomization_summary_email: "subject_randomization_summary_email",
    thirty_day_follow_up_completed_notification_email: "thirty_day_follow_up_completed_notification_email",
    trial_documents: "trial_documents",
    two_day_reminder_notification_email: "two_day_reminder_notification_email",
    unblinding_request_approved_notification_email: "unblinding_request_approved_notification_email",
    unblinding_request_list: "unblinding_request_list",
    unblinding_request_pending_notification_email: "unblinding_request_pending_notification_email",
    user_login: "user_login",
    user_login_validate_mfa_code: "user_login_validate_mfa_code",
    user_login_with_mfa: "user_login_with_mfa",
    user_login_with_mfa_email: "user_login_with_mfa_email",
    user_login_with_mfa_sms: "user_login_with_mfa_sms",
    user_login_without_mfa: "user_login_without_mfa",
    user_logout: "user_logout",
    user_password_set_password: "user_password_set_password",
    user_recover: "user_recover",
    user_recover_confirm_token: "user_recover_confirm_token",
    user_recover_email: "user_recover_email",
    user_recover_update_password: "user_recover_update_password",
    user_set_password: "user_set_password",
    user_set_password_confirm_token: "user_set_password_confirm_token",
    user_set_password_email: "user_set_password_email",
    validate_randomization_notification_email: "validate_randomization_notification_email",
    validation: "validation",
    validation_death_deviation_notification_email: "validation_death_deviation_notification_email",
    validation_differs_from_randomization_notification_email: "validation_differs_from_randomization_notification_email",
    validation_protocol_deviation_notification_email: "validation_protocol_deviation_notification_email",
    validation_step_1: "validation_step_1",
    validation_step_3: "validation_step_3",
    invoice_generate_events: "invoice_generate_events",
    site_activated_notification_email: "site_activated_notification_email",
    admin_activate_user_role_notification_email: "admin_activate_user_role_notification_email",
    admin_deactivate_user_role_notification_email: "admin_deactivate_user_role_notification_email",
    admin_activate_user_notification_email: "admin_activate_user_notification_email",
    admin_deactivate_user_notification_email: "admin_deactivate_user_notification_email",
    admin_drug_quarantined_notification_email: "admin_drug_quarantined_notification_email",
    admin_drug_shipment_received_at_site_notification_email: "admin_drug_shipment_received_at_site_notification_email",
    admin_drug_received_at_active_fridge_notification_email: "admin_drug_received_at_active_fridge_notification_email",
    randomization_site_suspended_notification_email: "randomization_site_suspended_notification_email",
    randomization_site_activated_notification_email: "randomization_site_activated_notification_email",
    audit_log_bulk_reviewed: "audit_log_bulk_reviewed",
    audit_log_bulk_unreviewed: "audit_log_bulk_unreviewed",
    report_user_account_csv_email: "report_user_account_csv_email",
    report_user_account_txt_email: "report_user_account_txt_email",
    report_user_account_pdf_email: "report_user_account_pdf_email",
    report_all_vials_csv_email: "report_all_vials_csv_email",
    report_all_vials_txt_email: "report_all_vials_txt_email",
    admin_specimen_sample_management_upload: "admin_specimen_sample_management_upload",
};



// WEBPACK FOOTER //
// ./src/containers/AuditLogs/actionTypes.js